import { doc, getDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { db, store } from "shared/api/firebase";
import { ModuleData, CardBlockImage } from "../types";
import { THREE_CARD_BLOCK_KEY } from "../utils";

type Params = {
  moduleId: string;
  threeCardBlockImages: CardBlockImage[];
};

export const saveContentBlocksImages = async ({
  moduleId,
  threeCardBlockImages,
}: Params) => {
  try {
    const docRef = doc(db, "moduleTemplates", moduleId);

    const moduleData = (await getDoc(docRef)).data() as ModuleData;

    if (!moduleData.contentBlocks || !moduleData.contentBlocks.length) {
      return null;
    }

    const contentBlocks = await Promise.all(
      threeCardBlockImages.map(async (imageFile, index) => {
        const block = moduleData.contentBlocks?.find((i, idx) => idx === index);

        if (!imageFile) {
          return block;
        }

        // References for logo and background images
        const path = `moduleTemplates/${moduleId}/${THREE_CARD_BLOCK_KEY}-${index}`;
        const imgStorageRef = ref(store, path);

        await uploadBytes(imgStorageRef, imageFile);

        return { ...block, backgroundImage: path };
      }),
    );

    await updateDoc(docRef, {
      contentBlocks,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error saving module image:", error);
    throw error; // Or handle it in a way that's appropriate for your app
  }
};
